// Service to display notification toast over app
import { toast } from 'vue-sonner';

const resolveDuration = (duration) => (duration === 'infinite' ? Infinity : duration);

export const notify = {
  success(title, options) {
    toast.success(title, {
      description: options?.description,
      duration: resolveDuration(options?.duration) ?? 4000,
      class: 'toast--success',
      style: {
        background: 'rgb(15, 44, 26)',
        border: '1px solid rgba(9, 255, 0, 0.2)',
      },
    });
  },

  error(title, options) {
    toast.error(title, {
      description: options?.description,
      duration: resolveDuration(options?.duration) ?? 5000,
      class: 'toast--error',
      style: {
        background: 'rgb(78, 20, 18)',
        border: '1px solid rgba(255, 85, 0, 0.32)',
      },
    });
  },

  warning(title, options) {
    toast.warning(title, {
      description: options?.description,
      duration: resolveDuration(options?.duration) ?? 4500,
      class: 'toast--warning',
      style: {
        background: 'rgb(75, 39, 18)',
        border: '1px solid rgba(255, 85, 0, 0.36)',
      },
    });
  },

  info(title, options) {
    toast.info(title, {
      description: options?.description,
      duration: resolveDuration(options?.duration) ?? 4000,
      action: options?.action,
      class: 'toast--info',
      descriptionClass: 'description-info',
      style: {
        background: '#283f74',
        border: '1px solid rgba(0, 221, 255, 0.2)',
      },
    });
  },
};
